// src/pages/usa/OregonCoast.js
import "../../App.css";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import BackOnly from "../../components/BackOnly";
import ContactPopup from "../../components/ContactPopup";
import React, { useState, useEffect } from "react";
import AffiliateBooking from "../../components/affiliate/AffiliateBooking";
import AffiliateExpedia from "../../components/affiliate/AffiliateExpedia";
import AffiliateTrip from "../../components/affiliate/AffiliateTrip";

import { useNavigate, useLocation } from "react-router-dom";   // ⭐ REQUIRED

// ⭐ STRICT COMMAND: Cape May ALWAYS goes back to New Jersey map
export const backRoute = "/map/NewJersey";

export default function CapeMay() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { hash } = useLocation();   // ⭐ REQUIRED for hash scrolling

  // ⭐ Send strict back command to BackOnly (NO LOOPS)
  useEffect(() => {
    if (!window.__newjerseyBackRouteSet) {
      window.__newjerseyBackRouteSet = true;
      navigate(".", { replace: true, state: { backRoute } });
    }
  }, [navigate]);

  // ⭐ Smooth scroll to section when hash is present
  useEffect(() => {
    if (!hash) return;

    // Wait for DOM to finish rendering
    setTimeout(() => {
      const id = hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 50);
  }, [hash]);

  return (
    <>
      <Header />

      <div className="visited-back-wrapper">
        <BackOnly />
      </div>

      <div className="page-container" style={{ padding: "12px" }}>
        <h1>New Jersey</h1>

        <section className="travel-review">
          {/* LEFT COLUMN */}
          <div className="travel-text">
            <h2>🏞️  Cape May / New Jersey</h2>


          <p>
  The trip to Cape May was a short one, but exactly what I needed — a perfect escape from the snowy mountains
   of Colorado during the winter. I drove down from Philadelphia, which took about two hours, and the drive 
   itself was pretty smooth. Little by little, the scenery shifted from the familiar city views into long
    stretches of green, quiet roads, and that almost‑wild, peaceful landscape. As I got closer to the 
    coast, everything changed again — more greenery, coastal vibes, and that fresh ocean air you can feel even
     before you reach the beach.
</p>

            {/* GETTING THERE */}
            <h3>🚗 Getting There</h3>

          
            <p>
  I flew into Philadelphia International Airport and drove down to Cape May. The drive took about two hours and 
  was pretty straightforward. There are actually two main routes you can take to reach Cape May. One option 
  takes you through Atlantic City, which is a longer coastal route with several tolls along the way. The other
   route is the shorter one, avoiding most tolls and staying inland for most of the drive. I chose the
    simpler, toll‑free route, which kept me on the highway and then onto US‑9 South, leading directly into
     Cape May.   I’ve never flown directly into Cape May, but there is also a small local airport 
     nearby — Cape May Airport (WWD) — which handles private and seasonal regional flights for travelers
      looking for an even closer option.
</p>


            {/* PERSONAL OBSERVATION */}
            <h3>🌟 My Personal Observation</h3>        
            <ul>
              <li>
               <div id="CapeMay Downtown"> </div>       
                  <div className="place-block">
    
                        <strong>Cape May Downtown: </strong>
    Cape May’s downtown area is a charming blend of Victorian architecture, boutique shops, and cozy cafes. 
    Walking through the streets feels like stepping back in time, with beautifully preserved buildings and a
    relaxed, welcoming atmosphere. The local shops offer everything from handmade crafts to delicious treats,
    making it a great place to explore on foot. The vibe is laid‑back and friendly, perfect for a leisurely 
    afternoon of shopping and dining.
    <br />
    Is a great touristic area, during the summer it can get really crowded, but in the winter it’s much more
     peaceful and you can enjoy the beauty of the place without the crowds. Most of the restaurants and shops are open
      year‑round, so it’s a great destination no matter when you visit. The beach is just a short walk from 
      downtown, and the views of the ocean are stunning, especially at sunset.  
    <br />
    <a
      href="https://www.google.com/maps?q=38.932574141239016, -74.92319935468024"
      target="_blank"
      rel="noopener noreferrer"
    >
      📍 Cape May Downtown
    </a>
  
  </div>
</li>

<li>
   
  <div className="place-block">
    <strong>Wildwood: </strong>
   Wilwood is a lively beach town just a few miles from Cape May, known for its wide beaches, vibrant 
   boardwalk, and fun atmosphere. The boardwalk is packed with amusement parks, arcades, and food
    stands, making it a popular destination for families and anyone looking for a classic beach day
     experience. The beaches are spacious and perfect for sunbathing, swimming, or just relaxing by the
      ocean. Wildwood has a more energetic vibe compared to the quieter Cape May, so it’s a great spot if 
      you’re looking for some fun and entertainment along with your beach time.
    <br />
    The sad part is that during the winter, most of the attractions and shops along the boardwalk are
     closed, so it can feel a bit deserted. However, the beach itself is still open and can be a peaceful 
     place to visit if you don’t mind the colder weather. The views of the ocean are just as beautiful in 
     the winter, and you can enjoy a quiet walk along the shore without the summer crowds.
    <br />
    <a
      href="https://www.google.com/maps?q=38.98006546212174, -74.81985417701907"
      target="_blank"
      rel="noopener noreferrer"
    >
      📍 Board Walk
    </a>
  </div>
</li>
            
 </ul>

           
            {/* HIDDEN GEMS */}
            <h3>🌲 Hidden Gems</h3>

<ul>
        <li>
   
  <div className="place-block">
    <strong>The Lighthouse and Fort Miles Battery 223: </strong>
    The Cape May Lighthouse is a historic landmark that offers stunning views of the Atlantic Ocean and the 
    surrounding coastline.  There are some trails around the lighthouse that allow you to explore the area and
     enjoy the natural beauty of the coast.  One of the trails leads to Fort Miles Battery 223, which is a 
     World War II coastal defense site. The battery is well preserved and offers a fascinating glimpse into 
     the history of coastal defense during the war.
    <br />
    <a
      href="https://www.google.com/maps?q=38.9315346514476, -74.95572638532931"
      target="_blank"
      rel="noopener noreferrer"
    >
      📍 View on Google Maps
    </a>
  </div>
</li>
 <li>
   
  <div className="place-block">
    <strong>The Spearlak Gallery and Sculpture Park: </strong>
    The Spearlak Gallery and Sculpture Park is a unique cultural destination in Cape May, featuring a 
    collection of contemporary sculptures and rotating art exhibitions. The park offers a peaceful 
    retreat with walking trails and scenic views of the coastline.
    <br />
    <a
      href="https://www.google.com/maps?q=39.15627790717884, -74.84418814747802"
      target="_blank"
      rel="noopener noreferrer"
    >
      📍 View on Google Maps
    </a>
  </div>
</li>


              <li>
   
  <div className="place-block">
    <strong>Woodland Village/Mini Town: </strong>
   The Woodland Village/Mini Town is a unique attraction in Cape May that features a collection of miniature buildings and 
   landmarks. It’s a fun and quirky place to visit, especially if you’re interested in architecture or just 
   want to see something different. The mini town includes detailed replicas of local buildings, as well as 
   famous landmarks from around the world. It’s a great spot for photos and a fun way to learn about the 
   history and culture of Cape May in a lighthearted way.
      <br />
    <a
      href="https://www.google.com/maps?q=39.14803182042864, -74.76438273457318"
      target="_blank"
      rel="noopener noreferrer"
    >
      📍 View on Google Maps
    </a>
  </div>
</li>
<li>
  <div className="place-block">
    <strong>Naval Air Station Wildwood Aviation Museum:</strong>
    Located at the Cape May Airport, this aviation museum is housed inside a 
    restored World War II hangar. Visitors can explore historic aircraft, 
    military vehicles, interactive exhibits, and aviation artifacts. It’s a 
    great stop for families, history lovers, and anyone interested in military 
    aviation. The museum offers a hands‑on experience where you can even climb 
    into some of the aircraft.
    <br />
    <a
      href="https://www.google.com/maps?q=39.00472023943969,-74.90903811443029"
      target="_blank"
      rel="noopener noreferrer"
    >
      📍 View on Google Maps
    </a>
  </div>
</li>

</ul>

            {/* PLACES TO STAY */}
           <h3>🛏️ Places to Stay in Cape May</h3>

<p>
  Cape May offers a mix of charming beach houses, boutique inns, and 
  oceanfront hotels. Below is a curated list of great stays, starting 
  with a highly recommended Airbnb option, followed by several well‑known hotels. 
  Each place has its own unique charm and amenities,
</p>

<ul>

  <li>
    <div className="place-block">
      <strong>The Kraken House (Airbnb):</strong>
      I’ve stayed here three times, and the place has always been spotless. 
      It’s perfect for families or small groups, offering plenty of space, 
      comfort, and a relaxed beach‑house vibe. The location is excellent — 
      just a short walk to the beach — and everything in the house is 
      well‑maintained. For me, it’s a <strong>100% recommended</strong> stay.
      <br />
      <a
        href="https://www.google.com/maps?q=39.03298180048829,-74.93528990530064"
        target="_blank"
        rel="noopener noreferrer"
      >
        📍 View on Google Maps
      </a>
      <br />
      <a
        href="https://www.airbnb.com/rooms/47785549"
        target="_blank"
        rel="noopener noreferrer"
      >
        🔗 View on Airbnb
      </a>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>ICONA Cape May:</strong>
      Elegant beachfront hotel with bright, modern rooms and excellent service. 
      Located steps from the sand and close to Cape May’s historic district.
      <br />
      <em>Available on Expedia & Booking.com</em>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Montreal Beach Resort:</strong>
      A popular oceanfront stay with a pool, beach bar, and direct beach access. 
      Great for families and couples looking for convenience and comfort.
      <br />
      <em>Available on Expedia & Booking.com</em>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>La Mer Beachfront Resort:</strong>
      Spacious rooms, ocean views, and a peaceful beachfront location. 
      Known for its clean facilities and relaxing atmosphere.
      <br />
      <em>Available on Expedia & Booking.com</em>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Grand Hotel of Cape May:</strong>
      Classic beachfront hotel with indoor and outdoor pools, restaurants, 
      and a family‑friendly environment. A solid choice for larger groups.
      <br />
      <em>Available on Expedia & Booking.com</em>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Beach Shack:</strong>
      A laid‑back, pet‑friendly beachfront hotel with a fun, casual vibe. 
      Perfect for travelers who want to stay right by the ocean.
      <br />
      <em>Available on Expedia & Booking.com</em>
    </div>
  </li>

</ul>



            {/* AFFILIATE BLOCK */}
            <h3>If you are looking for a place to stay, you can check prices, date and time here.</h3>
                        <div className="affiliate-block">
                          <AffiliateExpedia />
                          <AffiliateBooking />
                          <AffiliateTrip />
                        </div>
            {/* VIDEOS */}
          <h3>🎥 My Travel Videos</h3>

<p>
  I took these videos from the Columbia River Highway, Oregon Coast, Silver Falls State Park, 
  and my recent trip to Cape May. Set the YouTube video quality to high resolution — I hope you enjoy them.
</p>

<p>
  <a
    href="https://youtu.be/3R4o-Aqu14Y?si=36q3-3ibELGf272r"
    target="_blank"
    rel="noopener noreferrer"
  >
    Battery 223 and Cape May Lighthouse
  </a>
  <br />

  <a
    href="https://youtu.be/oSX4ddHuRh4?si=mKO47sq1cQIKTbY3"
    target="_blank"
    rel="noopener noreferrer"
  >
    Cape May Downtown
  </a>
  <br />

  <a
    href="https://youtu.be/esf6WRlW6nQ?si=KzdiaHfeDrYNLmcG"
    target="_blank"
    rel="noopener noreferrer"
  >
    Lookout Tower and Cape May Point
  </a>
  <br />
</p>

          </div>

          {/* RIGHT COLUMN */}
          <div className="travel-image-column">
           
            <a
              href="https://youtu.be/3R4o-Aqu14Y?si=36q3-3ibELGf272r"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/capemay/bat1.jpg"
                alt="Battery 223 and Cape May Lighthouse Video"
              />
            </a>

            <a
              href="https://youtu.be/oSX4ddHuRh4?si=mKO47sq1cQIKTbY3"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/capemay/cmd1.jpg"
                alt="Cape May Downtown Video"
              />
            </a>

            <a
              href="https://youtu.be/esf6WRlW6nQ?si=KzdiaHfeDrYNLmcG"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/capemay/tower.jpg"
                alt="Lookout Tower Video"
              />
            </a>
            
            <img src="/images/usa/capemay/cmd2.jpg" alt="Cape May Downtown" />
            <img src="/images/usa/capemay/cmd3.jpg" alt="Cape May Downtown" />
            <img src="/images/usa/capemay/lh.jpg" alt="Lighthouse" />
            <img src="/images/usa/capemay/beach.jpg" alt="Beach" />
            <img src="/images/usa/capemay/bat2.jpg" alt="Battery 223" />
             <img src="/images/usa/capemay/fireworks.jpg" alt="Fireworks" />
              <img src="/images/usa/capemay/monstertruck.jpg" alt="Monster Truck" />
               <img src="/images/usa/capemay/beachsunset.jpg" alt="Beach Sunset" />
                <img src="/images/usa/capemay/knomepark.jpg" alt="Knome Park" />
                <img src="/images/usa/capemay/knomepark2.jpg" alt="Knome Park" />
           
            
          </div>
        </section>
      </div>

      {/* EMAIL BUTTON */}
      <div className="email-wrapper">
        <button className="email-link" onClick={() => setOpen(true)}>
          contact@thefindingspot.com
        </button>
      </div>

      {/* POPUP */}
      <ContactPopup isOpen={open} onClose={() => setOpen(false)} />

      <Footer />
    </>
  );
}
